export default __webpack_public_path__ + "static/media/vitalik_nft_16.ff73dea0.svg";